import { readable } from 'svelte/store';
import { ClassData } from '../dataTypes/classData';
import { FunctionData } from '../dataTypes/functionData';
import jsonDocumentations from '../data/documentations.json';
const documentations = DeserializeDocumentations(jsonDocumentations);
function DeserializeDocumentations(jsonDocumentations) {
    const documentations = new Map();
    for (const jsonDocumentation of jsonDocumentations) {
        switch (jsonDocumentation.type) {
            case "class":
                documentations.set(jsonDocumentation.id, new ClassData().deserialize(jsonDocumentation));
                break;
            case "function":
                documentations.set(jsonDocumentation.id, new FunctionData().deserialize(jsonDocumentation));
                break;
        }
    }
    return documentations;
}
const documentationsStore = readable(documentations, set => {
    set(documentations);
});
export { ClassData, FunctionData, documentationsStore };
